import { ErrorCode } from './catalog';

export class AppErrorBase extends Error {
  code: ErrorCode;
  context?: Record<string, unknown>;
  cause?: unknown;

  constructor(params: {
    code: ErrorCode;
    message: string;
    context?: Record<string, unknown>;
    cause?: unknown;
  }) {
    super(params.message);
    this.name = 'AppError';
    this.code = params.code;
    this.context = params.context;
    this.cause = params.cause;
    Object.setPrototypeOf(this, AppErrorBase.prototype);
  }
}

export class ApiError extends AppErrorBase {
  status?: number;

  constructor(params: {
    code: ErrorCode;
    message: string;
    status?: number;
    context?: Record<string, unknown>;
    cause?: unknown;
  }) {
    super({
      code: params.code,
      message: params.message,
      context: params.context,
      cause: params.cause
    });
    this.name = 'ApiError';
    this.status = params.status;
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class NetworkError extends ApiError {
  constructor(message = 'Network error', context?: Record<string, unknown>, cause?: unknown) {
    super({ code: ErrorCode.NETWORK, message, context, cause });
    this.name = 'NetworkError';
    Object.setPrototypeOf(this, NetworkError.prototype);
  }
}

export class TimeoutError extends ApiError {
  constructor(message = 'Request timeout', context?: Record<string, unknown>, cause?: unknown) {
    super({ code: ErrorCode.TIMEOUT, message, context, cause });
    this.name = 'TimeoutError';
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}

export class RateLimitError extends ApiError {
  constructor(message = 'Rate limit exceeded', context?: Record<string, unknown>, cause?: unknown) {
    super({ code: ErrorCode.RATE_LIMIT, message, context, cause });
    this.name = 'RateLimitError';
    Object.setPrototypeOf(this, RateLimitError.prototype);
  }
}
